// derive top length of array-type items in records;

import type { useQuery } from "@apollo/client/react";
import { XYSeriesConfigBar } from "@jana-technology/platform-ui";

import type { SystemOverviewTotalChartsQuery } from "$/__generated__/graphql";

// item will have other fields which we don't care about;
export const getTheLongestItemLength = (
  items: Array<Record<string, Array<unknown> | string | number | null>>,
  itemKey: string,
) => {
  const itemLengths = items.map((item) => {
    const itemArray = Array.isArray(item[itemKey]) ? item[itemKey] : [];

    return itemArray.length;
  });

  return Math.max(...itemLengths);
};

// mainly for sonar cloud code duplication; not needed
export const makeRiskDatumObject =
  (
    yKey: string,
    xIndex: number,
    data: NonNullable<
      useQuery.Result<SystemOverviewTotalChartsQuery>["data"]
    >["systemOverviewTotalCharts"],
    type = "",
  ) =>
  (
    item: Array<
      Record<
        string,
        | string
        | number
        | Array<Record<string, string | number | null | undefined>>
        | undefined
      >
    >,
    index: number,
  ) =>
    ({
      x: data?.[index]!.fieldName
        ? `${data[index].fieldName}${type}`
        : `Field ${index + 1}${type}`,
      y: Number(item[xIndex][yKey]),
      label: item[xIndex].group as string,
    }) satisfies XYSeriesConfigBar["data"][number];

export const removeInvalidDataPoints = (datum: {
  y: number | null | undefined;
  label?: string;
}) => {
  return (
    typeof datum.y === "number" &&
    !isNaN(datum.y) &&
    typeof datum.label === "string" &&
    datum.label.length > 0
  );
};

export const returnTopRiskWellsChartTitle = (
  tab: "riskByThreatsData" | "riskByConsequenceData" | "riskByOutcomeData",
): string => {
  switch (tab) {
    case "riskByThreatsData":
      return "Top Risk Wells by Threat";
    case "riskByConsequenceData":
      return "Top Risk Wells by Consequence";
    case "riskByOutcomeData":
      return "Top Risk Wells by Outcome Scenario";
    default:
      throw new Error("Invalid tab value");
  }
};
